import { Tab, TabList, TabPanel, TabPanels, TabGroup } from "@headlessui/react";

import Image from "next/legacy/image";
import { IconLocationPin } from "../../styles/icons";

import { useEffect, useState } from "react";

export const ViewSectionOfficeMap = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [addresses, setAddresses] = useState([]);
  const [hasInPerson, setHasInPerson] = useState(false);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  useEffect(() => {
    setAddresses(
      props.profile.addresses.filter((elem) => elem.postcode !== "ONLINE"),
    );
  }, [props.profile.addresses]);

  useEffect(() => {
    setHasInPerson(
      props.profile.sessionTypes.filter((type) => type.value === "1").length >
        0,
    );
  }, [props.profile.sessionTypes]);

  useEffect(() => {
    const _addresses = addresses.filter(
      (address) =>
        (address.location?.lat && address.location.lng) ||
        (Array.isArray(address.latlon) && address.latlon.length >= 2),
    );

    if (_addresses.length < 1) {
      return;
    }
    const [address] = _addresses;
    if (address.location?.lat) {
      setLat(address.location.lat);
      setLng(address.location.lng);
    } else {
      setLat(address.latlon[0]);
      setLng(address.latlon[1]);
    }
  }, [addresses]);

  // Helpers
  const handleTabsChange = (index) => {
    setTabIndex(index);
    setLat(addresses[index].location.lat);
    setLng(addresses[index].location.lng);
  };

  if (addresses === null || !hasInPerson) return <></>;

  return (
    <div className="flex-col rounded-t-[20px] overflow-hidden">
      <div className="relative h-[220px] w-full">
        {lat && (
          <Image
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=420x220&key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_JS_API}&markers=color:red%7C${lat},${lng}`}
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            alt="profile header image"
            px={{ base: "20px", md: "none" }}
            unoptimized
          />
        )}
      </div>
      <div className="p-[20px_0px_20px_0px]">
        <TabGroup onChange={handleTabsChange} selectedIndex={tabIndex}>
          <TabList className="flex">
            {addresses.map((address, i) => (
              <Tab
                key={i}
                data-custom={tabIndex === i ? "selected" : "not"}
                className="rounded-t-[10px] font-bold py-2.5 px-4 w-full flex items-center justify-center gap-2 text-brand data-[custom=selected]:bg-brand-off data-[custom=selected]:text-brand-alt"
              >
                <IconLocationPin />
                {`${addresses.length > 1 ? `${i + 1}. ` : ""} ${address.city}`}
              </Tab>
            ))}
          </TabList>
          <TabPanels>
            {addresses.map((address, i) => (
              <TabPanel
                key={i}
                data-custom={tabIndex === i ? "selected" : "not"}
                className="p-[15px] data-[custom=selected]:bg-brand-off rounded-b-[10px]"
              >
                <p className="font-bold">
                  Practice address -{" "}
                  {addresses.length > 0 ? address.city : "Online only "}
                </p>
                <p className="text-sm">{address.address}</p>
                <p className="text-sm">{address.city}</p>
                <p className="text-sm">{address.postcode}</p>
              </TabPanel>
            ))}
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  );
};
